import { render, staticRenderFns } from "./AdminControls.vue?vue&type=template&id=30e65725&"
import script from "./AdminControls.vue?vue&type=script&lang=ts&"
export * from "./AdminControls.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports